import React, { PureComponent } from 'react';
import { Cell, BodyRow } from '@ro-atoms/RoTable';
import Input from '@ro-atoms/Input';
import { Box, Flex } from '@rebass/grid';

import Icon from '@ro-atoms/Icon';
import Button from '@material-ui/core/Button';

import { SpIconWrapper, Location } from '../../RoTooltip.styles';

type Props = {
  locationName: string;
  text?: string;
  setTitle: (value: string) => void;
  onShowSnack: Function;
  setFavoriteLocation: Function;
  findNameOnFavorite: Function;
};

export class FavoriteLocation extends PureComponent<Props> {
  setFavoriteLocation = () => {
    const { locationName, onShowSnack, setFavoriteLocation, findNameOnFavorite } = this.props;

    const isDefinedName = findNameOnFavorite(locationName);
    if (isDefinedName) {
      onShowSnack('warning', 'Ta nazwa jest na liście. Nazwy muszą być różne.');
    } else {
      setFavoriteLocation().then(() => {
        onShowSnack('success', 'Zapisano.');
      });
    }
  };
  render() {
    const { locationName } = this.props;
    return (
      <BodyRow>
        <Cell colSpan={2}>
          <Flex alignItems={'flex-end'}>
            <Box px={0}>
              <SpIconWrapper color="#fff" bg="#000" size={30}>
                <Icon name="map-marker fas" />
              </SpIconWrapper>
            </Box>
            <Box pl={2}>
              <Location>
                <Input
                  margin="normal"
                  placeholder="Twoja nazwa"
                  title={locationName}
                  setTitle={this.props.setTitle}
                  variant="outlined"
                />
              </Location>
            </Box>
            <Box pl={2}>
              <Location>
                <Button
                  size="small"
                  disabled={!locationName}
                  color="secondary"
                  variant="contained"
                  onClick={this.setFavoriteLocation}
                >
                  Dodaj do&nbsp;&nbsp;
                  <Icon name="heart fas" />
                </Button>
              </Location>
            </Box>
          </Flex>
        </Cell>
      </BodyRow>
    );
  }
}
